const getServiceRequest = ({
  showAlert,
  setLoading,
  serviceRequest,
  callback
}) => {
  setLoading(true);
  serviceRequest
    .then((response) => callback(response))
    .catch(({ error, message }) =>
      showAlert({ error, message, type: "danger" })
    )
    .finally(() => setLoading(false));
};

const addEditServiceRequest = async ({
  navigated,
  showAlert,
  setLoading,
  serviceRequest,
  callback
}) => {
  setLoading(true);
  serviceRequest
    .then((response) => {
      showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
      callback && callback(response);
      navigated && navigated(true);
    })
    .catch(({ error, message }) => {
      showAlert({ error, message, type: "danger" });
      navigated && navigated(false);
    })
    .finally(() => setLoading(false));
};

const updateServiceRequest = ({
  showAlert,
  setLoading,
  serviceRequest,
  refreshRequest,
  callback
}) => {
  setLoading(true);
  serviceRequest
    .then((_) => {
      showAlert({ error: "บันทึกสำเร็จ", type: "success" });
      if (callback) {
        if (refreshRequest)
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: refreshRequest,
            callback
          });
        else callback(_);
      }
    })
    .catch(({ error, message }) =>
      showAlert({ error, message, type: "danger" })
    )
    .finally(() => setLoading(false));
};

const deleteServiceRequest = ({
  showAlert,
  setLoading,
  serviceRequest,
  refreshRequest,
  callback
}) => {
  setLoading(true);
  serviceRequest
    .then((_) => {
      showAlert({ error: "ลบสำเร็จ", type: "success" });
      if (callback) {
        if (refreshRequest)
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: refreshRequest,
            callback
          });
        else callback;
      }
    })
    .catch(({ error, message }) =>
      showAlert({ error, message, type: "danger" })
    )
    .finally(() => setLoading(false));
};

export { getServiceRequest, addEditServiceRequest, deleteServiceRequest, updateServiceRequest };
